export default {"src":"/_next/static/media/bikeAccessories_24.86870ffb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};